import { render, staticRenderFns } from "./OrgTreeNode.vue?vue&type=template&id=54a1ed57&scoped=true&"
import script from "./OrgTreeNode.vue?vue&type=script&lang=js&"
export * from "./OrgTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./OrgTreeNode.vue?vue&type=style&index=0&id=54a1ed57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1ed57",
  null
  
)

export default component.exports